import React, { useMemo } from "react";
import "./Services.css";
import { useSEO } from "../components/SEO";
import scrollGif from "../assets/scroll.gif";

import rollerImg from "../assets/roller.webp";
import CustomisedRoller from "../assets/customized-roller.webp";
import motorizedImg from "../assets/motorized.webp";
import verticalImg from "../assets/vertical.webp";
import pvcExteriorImg from "../assets/pvc exterior.webp";
import zebraImg from "../assets/zebra.webp";
import extra1 from "../assets/customized.jpeg";
import extra2 from "../assets/bamboo.webp";
import extra3 from "../assets/venetian.webp";
import extra4 from "../assets/wooden.webp";
import extra5 from "../assets/industrial.webp";

function Services() {
  useSEO({
    title: "Our Blinds Collection | A-Z Blinds – Roller, Zebra, Vertical & More in Hyderabad",
    description: "Explore A to Z Blinds collection: roller blinds, zebra blinds, vertical blinds, motorized blinds, PVC exterior, venetian, wooden, bamboo and industrial blinds. Made to measure in Hyderabad.",
    keywords: "roller blinds, zebra blinds, vertical blinds, motorized blinds, venetian blinds, wooden blinds, bamboo blinds, PVC exterior blinds, custom blinds Hyderabad, blinds collection",
  });

  const stickyCollection = useMemo(
    () => [
      {
        title: "Roller Blinds",
        img: rollerImg,
        desc:
          "Sleek and minimal blinds for modern interiors.\nSmooth light control with effortless functionality.",
      },
      {
        title: "Customized\nRoller Blinds",
        img: CustomisedRoller,
        desc:
          "Roller blinds with high-quality custom image printing.\nAdd personal photos, artwork, or business branding to your windows.",
      },
      {
        title: "PVC Exterior\nBlinds",
        img: pvcExteriorImg,
        desc:
          "Durable outdoor protection from heat and dust.\nBuilt strong for balconies and exterior spaces.",
      },
      {
        title: "Motorised Roller\nBlinds",
        img: motorizedImg,
        desc:
          "Smart blinds controlled with a touch.\nConvenience, comfort, and modern automation.",
      },
      {
        title: "Vertical Blinds",
        img: verticalImg,
        desc:
          "Ideal for large windows and sliding doors.\nStructured design with easy light adjustment.",
      },
      {
        title: "Zebra Blinds",
        img: zebraImg,
        desc:
          "Dual-layer design for flexible light and privacy control.\nA contemporary touch with stylish functionality.",
      },
      {
        title: "Customized\nZebra Blinds",
        img: extra1,
        desc:
          "Zebra blinds with custom-designed printed layers.\nUnique visuals combined with flexible light control.",
      },
      {
        title: "Venetian Blinds",
        img: extra3,
        desc:
          "Classic horizontal slats for adjustable lighting.\nTimeless design that suits every interior.",
      },
      {
        title: "Wooden Blinds",
        img: extra4,
        desc:
          "Natural wood finish for a warm interior feel.\nPremium elegance with lasting durability.",
      },
      {
        title: "Bamboo Blinds",
        img: extra2,
        desc:
          "Eco-friendly design with earthy charm.\nSoft light filtering for relaxed spaces.",
      },
      {
        title: "Industrial Blinds",
        img: extra5,
        desc:
          "Heavy duty blinds built for large spaces.\nReliable performance with clean aesthetics.",
      },
    ],
    []
  );

  return (
    <div className="services-page">
      <section className="sticky-collection">
        <div className="sticky-collection__wrap">
          <div className="sticky-collection__head">
            <h1 className="sticky-collection__title">Explore Our Blinds Collection</h1>
            <p className="sticky-collection__sub">
              Modern designs. Smart functionality. Premium materials.
            </p>
            <div className="sticky-collection__scroll">
              <span>Scroll</span>
              <img
                className="sticky-collection__scrollGif"
                src={scrollGif}
                alt="Scroll down"
              />
            </div>
          </div>

          <div className="sticky-collection__grid">
            {stickyCollection.map((c, i) => (
              <div className="sticky-cardWrap" key={`${c.title}-${i}`}>
                <div className="sticky-card">
                  <img src={c.img} alt={c.title.replace(/\n/g, " ")} />
                  <div className="sticky-card__label">
                    <h3 style={{ whiteSpace: "pre-line" }}>{c.title}</h3>
                  </div>
                  <div className="sticky-card__overlay">
                    <h3 style={{ whiteSpace: "pre-line" }}>{c.title}</h3>
                    <p style={{ whiteSpace: "pre-line" }}>{c.desc}</p>
                  </div>
                </div>
                <div className="sticky-cardText">
                  <h3 style={{ whiteSpace: "pre-line" }}>{c.title}</h3>
                  <p style={{ whiteSpace: "pre-line" }}>{c.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Services;
